import { TIMER } from "../Gameplay";
import { Player } from "../Player/Player";
import { LevelManager } from "../Levels";


export class DeliveryBonus {

    private _pickupTime: number;
    private _curBonusLen: number;
    private _parcelCnt: number;

    /**
     * (RO) Aktualni pomer bonusu (1 az 0)
     */
    get bonusRatio(): number {
        if (this._pickupTime == undefined)
            return 0;

        let i = (TIMER.time - this._pickupTime) / this._curBonusLen;

        if (i > 1)
            i = 1;

        return 1 - i;
    }

    /**
     * (RO) Aktualni hodnota bonusu
     */
    get bonus(): number {
        let settings = LevelManager.INSTANCE.lvlSettings.deliveryBns;

        return Math.round(settings.minBonus + (settings.maxBonus - settings.minBonus) * this.bonusRatio);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._pickupTime = undefined;
        this._parcelCnt = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    start(parcelMaxPerCharCnt: number): void {
        // Nastavit cas pro ziskani bonusu
        this._pickupTime = TIMER.time;
        this._curBonusLen = LevelManager.INSTANCE.lvlSettings.deliveryBns.bonusLen;

        if (this._parcelCnt < parcelMaxPerCharCnt) {
            if ((this._parcelCnt = parcelMaxPerCharCnt) > 1) {
                // O jaky pomer dojde ke zpomaleni hrace za dany pocet balicku oproti neseni 1 balicku
                let i = (Player.WALK_SPEED_PKG_SLOWDOWN * (parcelMaxPerCharCnt - 1)) / (Player.instance.defWalkSpeed - Player.WALK_SPEED_PKG_SLOWDOWN);

                // Prodlouzit cas na ziskani bonusu
                this._curBonusLen *= (1 + i);
            }
        }
    }
}